import styled from 'styled-components';

import { Blurb } from 'components/Containers';
import colors from 'styles/theme/colors';
import AcceptedPlanIcon from 'svg/AcceptedPlan';

type AcceptedPlanProps = {
  planName: string;
  groupName: string;
};

export default function AcceptedPlan({ planName, groupName }: AcceptedPlanProps) {
  return (
    <PaddedBlurb data-cy='acceptedPlan'>
      <AcceptedPlanIcon width={16} height={16} />
      <TextSpan>
        {groupName} <AcceptsSpan>accepts</AcceptsSpan> {planName}
      </TextSpan>
    </PaddedBlurb>
  );
}

const PaddedBlurb = styled(Blurb)`
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

const TextSpan = styled.span`
  font-size: 12px;
  line-height: 20px;
  color: ${colors.black100};
`;

const AcceptsSpan = styled.span`
  font-weight: 500;
  color: #387802;
`;
